// extracted by mini-css-extract-plugin
export default {"ljiRed":"#ee2346","tasksGridWarning":"BaseTaskGrid_tasksGridWarning__nBR0y","container":"BaseTaskGrid_container__zn9c6"};